import { render, staticRenderFns } from "./switchResult.vue?vue&type=template&id=9059220a"
import script from "./switchResult.vue?vue&type=script&lang=js"
export * from "./switchResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports